import * as React from "react";
import { useResource, Resources } from "Translations/Resources";
import styled from "styled-components";
import { GoogleLogoIcon } from "Components/Shared/Icons/GoogleLogoIcon";
import { DefaultButton } from "Components/Shared/Buttons/DefaultButton";

const StyledButton = styled(DefaultButton)`
  border: 1px solid ${props => props.theme.colors.googleBtnBorder};
  box-shadow: ${props => props.theme.shadow.primary};

  &:hover,
  &:active {
    box-shadow: ${props => props.theme.shadow.primaryHover};
  }
`;

const StyledIcon = styled.span`
  display: inline-block;
  vertical-align: middle;
  margin-left: 8px;
  width: 18px;
  height: 18px;
  box-sizing: border-box;
  svg {
    width: 18px;
    height: 18px;
  }
`;

const StyledButtonText = styled.span`
  font-weight: 500;
  text-transform: none;
  padding: 0 24px;
  color: ${props => props.theme.palette.secondary.main};
`;

export const GoogleButton: React.FunctionComponent = _ => {
  const scope = process.env.REACT_APP_GOOGLE_URL;
  const redirectUri = process.env.REACT_APP_GOOGLE_REDIRECT_URL;
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  const { t } = useResource();

  const buttonClicked = () => {
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&access_type=offline&scope=${scope}&redirect_uri=${redirectUri}&client_id=${clientId}`;
  };
  return (
    <>
      <StyledButton type="button" onClick={buttonClicked}>
        <StyledIcon>
          <GoogleLogoIcon></GoogleLogoIcon>
        </StyledIcon>
        <StyledButtonText>{t(Resources.Auth.Google.Button)}</StyledButtonText>
      </StyledButton>
    </>
  );
};
